import React, { Component } from 'react';
import classNames from 'classnames';
import onClickOutside from 'react-onclickoutside';

import ProfileMenuList from './ProfileMenuList';


class ProfileMenu extends Component {
  handleClickOutside = (event) => {
    const { onClickOutside } = this.props;
    if (onClickOutside) {
      onClickOutside(event);
    }
  }

  render() {
    const { isOpened, onClickOutside, role } = this.props;

    return (
      <div
        className={classNames("header-profile__menu", {
          "header-profile__menu--opened": isOpened,
        })} >
        <div className="header-profile__menu-inner">
          <ProfileMenuList role={role} onClickOutside={onClickOutside} />
        </div>
      </div>
    )
  }
}

export default onClickOutside(ProfileMenu);
